import { SS, HLS_KR } from '../../utils/playerConstants';

let deviceInfo =
  window.AndroidPlayerInterface && window.AndroidPlayerInterface.getDeviceInformation
    ? window.AndroidPlayerInterface.getDeviceInformation()
    : '{}';
deviceInfo = JSON.parse(deviceInfo);


const multipleaudio = {};
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS];
supported_stream_types.live = [HLS_KR];
supported_stream_types.timeshift = [HLS_KR];

/* TODO add akamai_id to all config devices */
export default {
  appKey: '0577713445841eecca1931ceeb35fed8',
  // Request params
  device_category: 'stb',
  device_id: deviceInfo.device_id || 'XXX', // como obtener device id
  device_manufacturer: 'coship',
  device_model: 'android',
  device_name: deviceInfo.device_name || 'N9090', // como arman device Name
  device_so: deviceInfo.device_so || 'Android 4.4.2', // como obtener device_so
  device_type: 'stb',
  stream_type: 'smooth_streaming',
  appversion: deviceInfo.appversion || '503', // como obtener appversion
  firmwareversion: deviceInfo.firmwareversion || '001.999.999', // como obtener firmware version,
  useEpgPostals: true,
  akamai_id: 'AndroidAAF',
  nodetv: 'tv',
  // akamai_mfwk: 'mfwkcoship-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkcoship-api.clarovideo.net' : 'http://mfwkcoship-api.clarovideo.net'
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // serial_id: '2153017310HYGA500033'
  // init: init,
};



// WEBPACK FOOTER //
// ./src/devices/android/config.js